import 'regenerator-runtime/runtime.js';
import { useState } from 'react';
import useAxiosSubmit from './useAxiosSubmit';

const useGenerateAccessToken = () => {
  const [generateAccessTokenRequest, setGenerateAccessTokenRequest] = useState();
  const [url, setUrl] = useState();
  const { response, isLoading, hasErrored } = useAxiosSubmit(url, generateAccessTokenRequest);

  const generateAccessToken = async (request) => {
    setUrl(`${process.env.AUTHORITY}/connect/token`);
    setGenerateAccessTokenRequest(request);
  };

  return { response, error: hasErrored, isPending: isLoading, generateAccessToken };
};

export default useGenerateAccessToken;
